export * from './TextCTA';
export { StyledTextCTAButton, StyledTextCTALink, StyledTextCTAText } from './TextCTA.styles';

//# sourceMappingURL=index.js.map